<div class="form-builder-container pt-sm" (click)="closeAllFieldActions()">

  <div class="builder-content">
    <!-- Field List -->
    <div class="fields-list" appDragList (itemReordered)="onItemReordered($event)">

      <div class="flex flex-align-center flex-justify-space-between gap-md flex-wrap">
        <!-- Form columns picker -->
        <div class="form-columns-picker flex gap-sm flex-align-center">
          <span class="form-columns-label">{{ 'formBuilder.formColumns' | translate }}:</span>
          @for (col of [1, 2, 3, 4]; track col) {
          <button type="button" class="columns-btn" [class.active]="columns() === col"
            (click)="setColumns($any(col)); $event.stopPropagation()" [attr.data-testid]="'columns-btn-' + col">
            {{ col }}
          </button>
          }
        </div>
        <!-- Add Field Button -->
        <app-button variant="outlined" class="ml-auto" (click)="addField()" data-testid="add-field-button">
          <app-icon name="plus" />
          {{ 'formBuilder.addField' | translate }}
        </app-button>

      </div>

      @if (fields().length === 0) {
      <div class="empty-state p-3xl">
        <app-icon name="plus-circle" [size]="48" class="mb-md" />
        <p>{{ 'formBuilder.empty.title' | translate }}</p>
      </div>
      } @else {
      @for (field of fields(); track field.id; let i = $index) {
      <div class="field-item p-md gap-md" appDragItem [dragItemIndex]="i" data-testid="field-item">
        <div class="drag-handle" appDragHandle data-testid="drag-handle" [class.menu-open]="activeMenuIndex() === i"
          (click)="toggleFieldActions(i); $event.stopPropagation()">
          <app-icon name="grip-vertical" />
        </div>
        @if (activeMenuIndex() === i) {
        <div class="field-actions flex gap-md" (click)="$event.stopPropagation()">
          <app-button variant="icon" type="button" (click)="moveFieldUp(i)" [disabled]="i === 0"
            data-testid="move-up-button">
            <app-icon name="arrow-up" />
          </app-button>
          <app-button variant="icon" type="button" (click)="moveFieldDown(i)" [disabled]="i === fields().length - 1"
            data-testid="move-down-button">
            <app-icon name="arrow-down" />
          </app-button>
          <app-button variant="icon" type="button" (click)="editField(field)"
            [tippy]="'formBuilder.editField' | translate" data-testid="edit-field-button">
            <app-icon name="pencil" />
          </app-button>
        </div>
        }
        <div class="field-info clickable" (click)="editField(field)" (keydown.enter)="editField(field)"
          (keydown.space)="editField(field)" tabindex="0" role="button" data-testid="field-info">
          <div class="field-type-icon">
            <app-icon [name]="getFieldIcon(field.type)" />
          </div>
          <div class="field-details">
            {{ field.label }}
          </div>
        </div>
      </div>
      }
      }

    </div>
  </div>
</div>